import { http } from '@/app/lib/http/client'

// ─── Tipos de Datos ───────────────────
export type NotificationType = 'CRITICA' | 'INFORMATIVA'
export type NotificationStatus = 'all' | 'unread' | 'read'

// ─── Interfaz Principal ───────────────────
export interface UserNotification {
  id: number
  user_id: number
  type: NotificationType
  module: string | null
  is_redirectable: boolean
  title: string
  description: string | null
  details: {
    redirect_path?: string
    [key: string]: unknown
  } | null
  viewed_at: string | null
  created_at: string
  updated_at: string
}

export interface NotificationPage {
  data: UserNotification[]
  total: number
  current_page: number
  last_page: number
  per_page: number
}

// ─── Filtros ────────────────────────────────────
export interface NotificationFilters {
  page?: number
  per_page?: number
  status?: Exclude<NotificationStatus, 'all'>
  type?: NotificationType
  module?: string
}

// ─── El Objeto de Servicio ──
export const notificationService = {
  async getNotifications(filters: NotificationFilters = {}) {
    const response = await http.get('/notifications', { params: filters })
    return response.data.data as NotificationPage
  },

  // Obtener conteo de notificaciones sin leer
  async getUnreadCount() {
    const response = await http.get('/notifications/unread-count')
    return response.data.data.count as number
  },

  // Marcar una notificación como leida (vista)
  async markAsViewed(id: number | string) {
    const response = await http.post(`/notifications/${id}/view`)
    return response.data.data as UserNotification
  },

  // Marcar una notificación como no leída
  async markAsUnviewed(id: number | string) {
    const response = await http.post(`/notifications/${id}/unview`)
    return response.data.data as UserNotification
  },

  // Marcar todas las notificaciones del usuario como leidas
  async markAllAsViewed() {
    const response = await http.post('/notifications/view-all')
    return response.data.data as { updated: number }
  },

  // Eliminar una notificación específica
  async deleteNotification(id: number | string) {
    const response = await http.delete(`/notifications/${id}`)
    return response.data
  },

  // Eliminar un grupo completo de notificaciones
  async deleteGroup(module: string) {
    const response = await http.delete(`/notifications/destroy-group/${module}`)
    return response.data
  },

  // Limpiar la bandeja eliminando todas las notificaciones
  async deleteAll() {
    const response = await http.delete('/notifications/destroy-all')
    return response.data
  }
}
